import { LEVELS } from 'Components/foundation';
import { createStyleSheet } from 'Components/foundation/stylesheets';

const styleSheet = createStyleSheet({
  wrapper: {
    flex: 1,
  },
  title: {
    display: 'flex',
    backgroundColor: 'transparent',
    marginLeft: '18px',
    verticalAlign: 'top',
    minHeight: 32,
    width: 300,
    minWidth: 300,
  },
  content: {
    flex: 1,
    backgroundColor: 'transparent',
    display: 'flex',
    paddingLeft: '24px',
    marginTop: '7px',
    marginBottom: '7px',
    marginRight: '24px',
    width: 300,
    minWidth: 300,
  },
  image: {
    marginLeft: 24,
    minWidth: 30,
  },
  imageLabel: {
    minWidth: '133px',
  },
  iconsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '60px',
    height: '30px',
    marginRight: '16px',
  },
  settingsContainer: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 30,
    height: 30,
  },
  settingsDropdownContainer: {
    position: 'absolute',
    left: -12,
    top: 32,
    display: 'flex',
    zIndex: LEVELS.LOCAL_OFFSET_2,
  },
  settingsDropdown: {
    display: 'flex',
    flexDirection: 'column',
    gap: 11,
    padding: 12,
    borderRadius: 7,
    border: 'none',
    boxShadow:
      '0px 1px 3px 0px #00000014, 0px 6px 6px 0px #00000012, 0px 13px 8px 0px #0000000A, 0px 22px 9px 0px #00000003, 0px 35px 10px 0px #00000000',
  },
  settingsIcon: {
    borderRadius: 3,
  },
  linkContainer: {
    display: 'none',
    justifyContent: 'center',
    alignItems: 'center',
    width: 30,
    height: 30,
  },
});

export default styleSheet;
